module.exports = __webpack_public_path__ + "img/zdd_invite_lz_2.2f93ba93.png";